'use strict';

exports.__esModule = true;

var _fluxStandardAction = require('flux-standard-action');

function isThunk(payload) {
  return typeof payload === 'function';
}

function createFsaThunkMiddleWare(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if ((0, _fluxStandardAction.isFSA)(action) && isThunk(action.payload)) {
          dispatch(Object.assign({}, action, {
            payload: action.meta && action.meta.preThunkPayload ? action.meta.preThunkPayload : null
          }));
          return action.payload(dispatch, getState, extraArgument);
        }
        return next(action);
      };
    };
  };
}

var fsaThunk = createFsaThunkMiddleWare();
fsaThunk.withExtraArgument = createFsaThunkMiddleWare;

exports['default'] = fsaThunk;